
document.addEventListener("DOMContentLoaded", function () {
  // Init Splide sliders
  document.querySelectorAll(".productTabSec .splide").forEach(function (slider) {
    new Splide(slider, {
      perPage: 4,
      gap: '2.7rem',
      arrows: true,
      pagination: false,
      breakpoints: {
        1024: { perPage: 3 },
        768: { perPage: 2 },
        480: { perPage: 1 }
      }
    }).mount();
  });

    // community section
  document.querySelectorAll(".community__splide").forEach(function (slider) {
    new Splide(slider, {
      type   : 'loop',
      perPage: 5,
      gap: '2rem',
      padding: '8%',
      arrows: true,
      pagination: false,
      breakpoints: {
        1024: { perPage: 3 },
        768: { perPage: 2 },
        480: { perPage: 1 }
      }
    }).mount();
  });

  


// after before slider
   new Splide('.bland-grand-slider-wrap', {
      type   : 'loop',
      perPage: 3,
      perMove: 1,
      pagination: false,
      gap    : '2.9rem',
      padding: {
        right: "12%"
      },
      autoplay: true,
      breakpoints: {
        1024: { perPage: 2 },
        768 : { perPage: 1 }
      }
    }).mount();

   


    

    // Bundle  slider
   new Splide('.blandslider', {
      type   : 'loop',
      perPage: 4,
      perMove: 1,
      pagination: false,
      gap    : '2.9rem',
      autoplay: true,
      breakpoints: {
        1024: { perPage: 3 },
        991 : { perPage: 2 },
        480 : { perPage: 1 }
      }
    }).mount();


    

  // Tabs functionality
  const tabs = document.querySelectorAll(".productTabSec__tab");
  const contents = document.querySelectorAll(".productTabSec__content");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const target = this.dataset.tab;

      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      contents.forEach(c => c.classList.remove("active"));
      document.getElementById(target).classList.add("active");
    });
  });





// Tabs
const tabButtons = document.querySelectorAll(".ingredients-tabs__tab");
const tabPanels = document.querySelectorAll(".ingredients-tabs__content");

tabButtons.forEach(button => {
  button.addEventListener("click", function() {
    tabButtons.forEach(btn => btn.classList.remove("active"));
    tabPanels.forEach(panel => panel.classList.remove("active"));

    this.classList.add("active");
    document.querySelector(`.ingredients-tabs__content[data-tab="${this.dataset.tab}"]`).classList.add("active");
  });
});

// Accordion
const accordionTriggers = document.querySelectorAll(".accordion-header");

accordionTriggers.forEach(trigger => {
  trigger.addEventListener("click", function() {
    const accordionItem = this.parentElement;
    accordionItem.classList.toggle("active");
  });
});


});

